import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import { Button } from "@novaescola/eva-react-v2";

import { ibgeApi } from "../../../api/ibge/ibge.api";
import { AccountApi } from "../../../api/account/account.api";

const COOKIE_NAME = "ane-confirmation-block_4ab5f7bf59";
const COOKIE_REMATRICULA_NAME = "ane-confirmation-block_bfef93f29c";
const COOKIE_CLOSE_NAME = "ane-confirmation-block_close";

export const ConfirmationBlockTerritorio = ({ user, fetchUser }) => {
  const [hidden, setHidden] = useState(true);
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [userEstado, setUserEstado] = useState("");
  const [userCidade, setUserCidade] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    const token = Cookies.get("Bearer");

    setAccessToken(token);
    setHidden(false);

    fetchEstados();

    if (user.enderecos && user.enderecos.length > 0) {
      if (user.enderecos[0].estado) setUserEstado(user.enderecos[0].estado);

      if (user.enderecos[0].cidade) setUserCidade(user.enderecos[0].estado);
    }

    sendEventToDataLayer(
      "block_visualization",
      "JORNALISMO: matrícula - complementação de cadastro - territorio - bloco visualizado"
    );
  }, []);

  useEffect(() => {
    if (userEstado) fetchCidades();
  }, [userEstado]);

  const fetchEstados = async () => {
    const data = await ibgeApi.getEstados();
    setEstados(data);
  };

  const fetchCidades = async () => {
    const data = await ibgeApi.getCidades(userEstado);
    setCidades(data);
  };

  const sendEventToDataLayer = (event, label) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, label });
  };

  const handleSubmit = async () => {
    setSubmitted(true);

    const response = await AccountApi.updateUserTerritorio(
      accessToken,
      userCidade,
      userEstado
    );

    if (!response) {
      const expires = new Date();
      expires.setUTCDate(expires.getUTCDate() + 1);

      Cookies.set(COOKIE_CLOSE_NAME, "true", { expires });
      setHidden(true);

      return;
    }

    fetchUser(accessToken);

    const dtUltimaModificacao = new Date(user.dtUltimaModificacao);

    const lastYear = new Date();
    lastYear.setMonth(lastYear.getMonth() - 12);

    const finalEventLabel =
      user.enderecos &&
      user.enderecos.length > 0 &&
      user.enderecos[0].estado &&
      user.enderecos[0].cidade &&
      (dtUltimaModificacao < lastYear || Cookies.get(COOKIE_REMATRICULA_NAME))
        ? " - rematrícula"
        : "";

    sendEventToDataLayer(
      "confirmation_block",
      `JORNALISMO: matrícula - complementação de cadastro - território - botão enviar${finalEventLabel}`
    );
    sendEventToDataLayer(
      "confirmation_block",
      `JORNALISMO: matrícula - complementação de cadastro - território - estado ${userEstado}`
    );

    const expires = new Date();
    expires.setUTCFullYear(expires.getUTCFullYear() + 1);

    Cookies.set(COOKIE_NAME, "true", { expires });
    setHidden(true);
  };

  const handleClose = () => {
    const expires = new Date();
    expires.setUTCDate(expires.getUTCDate() + 1);

    Cookies.set(COOKIE_CLOSE_NAME, "true", { expires });
    setHidden(true);

    sendEventToDataLayer(
      "confirmation_block",
      "JORNALISMO: matrícula - complementação de cadastro - território - botão sair"
    );
  };

  if (hidden) return null;

  return (
    <div className="eva-bg-inst-50 eva-mb-07 eva-pr-05 eva-pl-05 eva-pb-05 eva-pt-05 confirmation-block">
      <div className="eva-mb-03 confirmation-block-title">
        <i className="far fa-circle-question eva-mr-03" />
        Em qual cidade você leciona?
      </div>
      <div className="row">
        <div className="col">
          <div className="confirmation-block-options-select">
            <label htmlFor="estado-select" className="eva-label">
              Estado *
            </label>
            <div className="eva-select-wrapper">
              <select
                id="estado-select"
                name="select"
                className="eva-select"
                value={userEstado}
                onChange={(event) => setUserEstado(event.target.value)}
              >
                <option disabled value="">
                  Selecione uma opção
                </option>
                {estados.map(({ sigla, nome }) => (
                  <option key={`select-estado-${sigla}`} value={sigla}>
                    {nome}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="confirmation-block-options-select">
            <label htmlFor="cidade-select" className="eva-label">
              Cidade *
            </label>
            <div className="eva-select-wrapper">
              <select
                id="cidade-select"
                name="select"
                className={`eva-select ${!userEstado && "eva-select-disabled"}`}
                disabled={!userEstado}
                value={userCidade}
                onChange={(event) => setUserCidade(event.target.value)}
              >
                <option disabled value="">
                  Selecione uma opção
                </option>
                {cidades.map(({ id, nome }) => (
                  <option key={`select-cidade-${id}`} value={nome}>
                    {nome}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="eva-mt-05">
        <Button
          type="button"
          variant="primary"
          size="small"
          disabled={submitted || (!userEstado && !userCidade)}
          onClick={handleSubmit}
        >
          Enviar
        </Button>
      </div>
      <button
        type="button"
        aria-label="Fechar"
        className="eva-cursor-pointer confirmation-block-close"
        onClick={() => handleClose()}
      >
        <i className="far fa-times"></i>
      </button>
    </div>
  );
};
